import React, { Suspense, lazy } from "react";
import BulkCreateSkeleton from "./BulkCreateSkeleton";

const BulkProductCreator = lazy(() => import("./index"));

/**
 * Eager shell so the app chrome stays up while the bulk-create chunk loads.
 * The page itself stays lazy.
 */
const BulkCreateRoute = () => (
  <Suspense fallback={<BulkCreateSkeleton />}>
    <BulkProductCreator />
  </Suspense>
);

export default BulkCreateRoute;
